import React from 'react';
import PropTypes from 'prop-types';

export default function Loading(props) {
  const { text } = props;
  return (
    <div className='km__c--loading-container'>
      <div className='km__c--loading-circle'>
        <div className='km__c--loading-dot'></div>
        <div className='km__c--loading-dot'></div>
        <div className='km__c--loading-dot'></div>
        <div className='km__c--loading-dot'></div>
        <div className='km__c--loading-dot'></div>
        <div className='km__c--loading-dot'></div>
      </div>
      <div className='km__c--loading-text'>{text}</div>
    </div>
  );
}

Loading.propTypes = {
  text: PropTypes.string,
};
